import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { Modal } from "../../DependencyHelper";
import { componentResize } from "../../../../utils/helperServices";
import styles from "./DropDown.module.scss";
import config from "../../../../config/index";
import labels from "../../../../config/labels";

const DropDown = ({
  formName,
  data,
  name,
  label,
  resetRequired,
  customId,
  customClassName,
  menuClassName,
  selectedId,
  fieldError,
  handleSelect,
  handleReset,
  handleBlur,
}) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const isMobile = componentResize();

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const handleListDisplay = () => {
    setShowOptionList((prevState) => !prevState);

    if (isMobile) {
      setModalShow(true);
    }

    isMobile
      ? document.body.classList.add("no-scroll")
      : document.body.classList.remove("no-scroll");
  };

  const resetClick = () => {
    if (handleReset) {
      handleReset(name, formName);
    }
    setShowOptionList(false);
    closeOptions();
  };

  const getValueLabel = () => {
    var item = data.find((item) => item.id == selectedId);
    var label = "";

    if (item) {
      if (item.label) {
        label = item.label;
      } else {
        label = item.name;
      }
    }
    return label;
  };

  const handleItemChange = (event) => {
    let eventTarget = event.target;
    let eventCurrentTarget = event.currentTarget;
    let dataId = eventCurrentTarget.getAttribute("data-id");
    let dataIndex = eventCurrentTarget.getAttribute("data-index");

    eventTarget.name = name;
    eventCurrentTarget.name = name;

    if (handleSelect) {
      if (formName) {
        handleSelect(event, dataId, formName, dataIndex);
      } else {
        handleSelect(event, dataId, dataIndex);
      }
    }
    if (handleBlur) {
      if (formName) {
        handleBlur(event, dataId, formName, dataIndex);
      } else {
        handleBlur(event, dataId, dataIndex);
      }
    }
    setShowOptionList((prevState) => !prevState);
    closeOptions();
  };

  const handleClickOutside = (e) => {
    if (
      !e.target.classList.contains(styles["select-component"]) &&
      !e.target.classList.contains(styles["selected-value"]) &&
      !e.target.classList.contains(styles["menu"]) &&
      !e.target.classList.contains(styles["menu-item"]) &&
      !e.target.classList.contains(styles["menu-item__name"]) &&
      !e.target.classList.contains(styles["modal__title"]) &&
      !e.target.classList.contains(styles["modal__label"]) &&
      !e.target.classList.contains(styles["modal__reset"])
    ) {
      setShowOptionList(false);
      document.body.classList.remove("no-scroll");
      closeOptions();
    }
  };

  useEffect(() => {
    // Add Event Listner to handle the click that happens outside
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Remove the event listner on component unmounting
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeOptions = () => {
    setModalShow(false);
  };

  const optionList = (
    <ul
      className={`${styles["menu"]} ${menuClassName}`}
      id={`menu-list-${customId}`}
    >
      {data.map((item, index) => (
        <li
          key={index}
          className={`${styles["menu-item"]} ${
            typeof selectedId !== undefined && selectedId == item.id
              ? styles["active"]
              : ""
          }`}
          data-id={item.id}
          data-index={index}
          onClick={(e) => handleItemChange(e)}
        >
          <span className={styles["menu-item__name"]}>
            {item.label ? item.label : item.name}
          </span>
          {typeof selectedId !== undefined && selectedId == item.id && (
            <img
              className={styles["green-icon"]}
              src={`${imagePrefix}/assets/images/icon-green-tick.svg`}
            />
          )}
        </li>
      ))}
    </ul>
  );

  return (
    <>
      <div
        onClick={handleListDisplay}
        className={`${styles["select-component"]}`}
      >
        <input
          type="text"
          name={name}
          placeholder="- Select -"
          value={getValueLabel()}
          readOnly={true}
          id={customId}
          className={`${
            fieldError
              ? `${styles["selected-value"]} ${styles["invalid"]}`
              : styles["selected-value"]
          } ${customClassName}`}
          onBlur={handleBlur}
        />
      </div>
      {showOptionList && !modalShow && optionList}
      {showOptionList && modalShow && (
        <Modal
          show={modalShow}
          onHide={closeOptions}
          className={styles["modal"]}
          dialogClassName="select-modal"
        >
          <div className={`${styles["modal__title"]}`}>
            <span
              onClick={closeOptions}
              className={styles["modal__close"]}
              id={`${label}_select_modal_close`}
            ></span>
            <span className={`${styles["modal__label"]}`}>{label}</span>
            {resetRequired && (
              <span
                className={`${styles["modal__reset"]}`}
                onClick={resetClick}
                id={`${label}-select-modal-reset`}
              >
                {labels.lbl_reset}
              </span>
            )}
          </div>
          <div className={styles["modal__body"]}>{optionList}</div>
        </Modal>
      )}
    </>
  );
};

DropDown.propTypes = {
  formName: PropTypes.string,
  data: PropTypes.array,
  label: PropTypes.string,
  resetRequired: PropTypes.bool,
  name: PropTypes.string,
  customId: PropTypes.string,
  customClassName: PropTypes.string,
  menuClassName: PropTypes.string,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldError: PropTypes.bool,
  handleSelect: PropTypes.func,
  handleReset: PropTypes.func,
  handleBlur: PropTypes.func,
};

DropDown.defaultProps = {
  data: [],
  label: "Modal",
  resetRequired: false,
  name: "select",
  fieldError: false,
  customId: "dropdown-component",
};

export default DropDown;
